export const setOpenGraphMetaTitle = (document: Document, title: string) => {
  const ogTitleTags = document.getElementsByName(`og:title`);

  if (ogTitleTags.length) {
    const titleTag: HTMLElement = ogTitleTags[0];
    titleTag.setAttribute(`content`, title);
  }
};
